'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.loadmaskReducer = loadmaskReducer;

var _constants = require('./shared/constants');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
  showLoadmask: []
};

function loadmaskReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  var showLoadmask = state.showLoadmask;

  switch (type) {
    case _constants.SHOW_LOADMASK:
      return _extends({}, state, { showLoadmask: [].concat(_toConsumableArray(showLoadmask), [new Date()]) });

    case _constants.HIDE_LOADMASK:
      return _extends({}, state, { showLoadmask: [].concat(_toConsumableArray(showLoadmask.slice(1))) });

    default:
      return state;
  }
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-redux-loadmask/lib/reducer.js
 ** module id = 500
 ** module chunks = 0
 **/